/**
 * Components that no longer exist. Saved workspaces and closed-component
 * history can still name them; restoring one would load a missing module, so
 * every restore and reopen path skips these names.
 */
export const RETIRED_COMPONENT_NAMES: ReadonlySet<string> = new Set([
  // One generic shell for the everyday tools, replaced by a dedicated viewer
  // per feature (PackagesViewer, HealthViewer, AccountsViewer, ...).
  "EverydayToolViewer",
  // The code-bridge task window the assistant's feedback tool used to open.
  "FeatureDeveloper",
  // The receipt for tickets the assistant filed directly; it now drafts the
  // ticket in the Feedback composer and the user sends it.
  "SupportTicketReceipt",
  // The standalone typed-chat widget; the sphere conversation now carries the
  // chat input.
  "ChatInput",
  // The "Always listening" chooser; saying the wake word is now the only way
  // to start listening.
  "VoiceActivationModeChooser",
  // The landing Capabilities window, later folded into the Why us window.
  "FunctionalityDeck",
  // The landing's Why us window; the home page now plays the why-us film
  // in its Videos window instead.
  "MaxScreenWindow",
]);

export function isRetiredComponentName(name: unknown): boolean {
  return typeof name === "string" && RETIRED_COMPONENT_NAMES.has(name);
}
